import { StyledWidget, StyledButton } from '@/components/styles';
import { Appointment } from '@/components';
import { useEffect, useState, useRef } from 'react';
import Icon from '@/assets/icons';
import { phones, socialContacts, email } from '@/lib/config';
import { useTranslation } from 'react-i18next';
import * as gtag from '@/lib/gtag'
import getCookie from '@/lib/getCookie'

export default function ContactWidget({ buttonAppearance = false, fixed = true }) {
  const [opened, setOpened] = useState(false);
  const ref = useRef(null);
  const { t } = useTranslation('global');
  const [gclid, setGclid] = useState(null);
  const [fbclid, setFbclid] = useState(null);
  const [wbraid, setWbraid] = useState(null);
  const [gbraid, setGbraid] = useState(null);

  useEffect(() => {
    setGclid(getCookie("gclid"));
    setFbclid(getCookie("fbclid"))
    setWbraid(getCookie("wbraid"))
    setGbraid(getCookie("gbraid"))
  }, []);

  useEffect(() => {
    const handleClick = (event) => {
      const classList = event.target.classList;
      if (classList.contains('modal-underlay') || (classList.contains('modal__close') && opened)) {
        setOpened(false);
      }
    };
    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, [opened]);
  return (
    <StyledWidget ref={ref} static={!fixed}>
      {buttonAppearance ? (
        <StyledButton onClick={() => setOpened(!opened)}>{t('contactUs')}</StyledButton>
      ) : (
        <StyledWidget.Button type="button" onClick={() => setOpened(!opened)}>
          {!opened && <Icon name="phone-big" width={30} height={30} />}
          {opened && <Icon name="close" width={19} height={20} />}
        </StyledWidget.Button>
      )}
      {opened && (
        <StyledWidget.Body under={buttonAppearance}>
          <StyledWidget.Section>
            <StyledWidget.Title>{t('contacts.call')}</StyledWidget.Title>
            {phones.map((phone, ind) => {
              const { title, href, icon } = phone;
              return (
                <StyledWidget.Item key={ind} href={href} onClick={() => gtag.gtag_report_conversion('AW-18230806173/QqvYCO2h770cEJ2NkPVD')}>
                  <Icon name={icon} width={20} height={20} stroke="#B69B64" />
                  {title}
                </StyledWidget.Item>
              );
            })}
          </StyledWidget.Section>

          <StyledWidget.Section>
            <StyledWidget.Title>{t('contacts.write')}</StyledWidget.Title>
            <StyledWidget.Item href={email.href}>
              <Icon name={email.icon} width={20} height={20} stroke="#B69B64" />
              {email.title}
            </StyledWidget.Item>
            {socialContacts.map((social, ind) => {
              const { name, icon, href } = social;
              const isWhatsapp = name.toLowerCase() === "whatsapp";
              let _href = href;
              if (isWhatsapp) {
                _href += '?text=Здравствуйте!%20Пишу%20с%20сайта%20—%20https://elemental.ae/%20'
              }
              if (isWhatsapp && gclid) {
                _href += `(gclid:${gclid}) `
              }
              if (isWhatsapp && fbclid) {
                _href += `(fbclid:${fbclid}) `
              }
              if (isWhatsapp && wbraid) {
                _href += `(wbraid:${wbraid}) `
              }
              if (isWhatsapp && gbraid) {
                _href += `(gbraid:${gbraid})`
              }
             
              return (
                <StyledWidget.Item
                    key={ind}
                    href={_href}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => {
                      if (isWhatsapp) {
                        gtag.gtag_report_conversion('AW-18230806173/O4BNCKbCvMAcEJ2NkPVD')}
                      }
                    }
                >
                  <Icon name={icon} width={20} height={20} />
                  {name}
                </StyledWidget.Item>
              );
            })}
          </StyledWidget.Section>
          <StyledWidget.Section>
            <Appointment render={AppointmentBtn} />
          </StyledWidget.Section>
        </StyledWidget.Body>
      )}
    </StyledWidget>
  );
}

function AppointmentBtn(props) {
  const { t } = useTranslation('global');
  return (
    <StyledWidget.AppointButton type="button" {...props}>
      {t('bookAppointment')}
    </StyledWidget.AppointButton>
  );
}
